<template>
  <div class="company-appointment-box">
    <img
      class="banner"
      :src="cdnresources + '/prod/images/hunan2021/LPXZ_2021_01.png'"
    />
    <div class="table">
      <div class="img-context-title">
        <div class="img-text">
          一、理赔报案流程
        </div>
        <img src="../../assets/img/insu_detail/title-right.png" alt="" />
      </div>
      <div class="context">
        <div class="context-title">
          关注“湖南爱民保”微信公众号，依次点击理赔服务＞理赔申请，根据提示上传理赔影像材料。
        </div>
      </div>
      <div class="img-context-title">
        <div class="img-text">
          二、理赔材料
        </div>
        <img src="../../assets/img/insu_detail/title-right.png" alt="" />
      </div>
      <div class="context">
        <div class="context-title">
          （一）住院及特殊病种门诊医疗费用保险金理赔资料：
        </div>
        <div class="context-text">
          1、保险金给付申请书及投保凭证或投保人证明；
          <br />2、被保险人身份证明（身份证或户口本，若被保险人是未成年人，需同时提供监护人身份证件、关系证明）；
          <br />3、湖南医保结算单原件、医疗费用发票或收据原件及对应费用明细总清单；
          <br />4、住院病历/特殊病种门诊病历/疾病诊断证明/出院小结（含病案首页、入院记录、影像检查报告、特殊病种审批表、首次确诊疾病诊断书等）
          <br />5、对于已经从当地基本医疗保险、公费医疗、城乡居民大病保险、其他费用补偿型医疗保险和其他途径获得补偿或给付的，需提供相应机构或单位出具的住院医疗费用结算证明或分报凭证；发票或收据上需盖报销机构或单位的公章；
          <br />6、受益人身份证明、银行卡复印件；
          <br />7、若由代理人代为申请保险金，则还应提供授权委托书、代理人法定身份证明等文件；
          <br />8、所能提供的与确认保险事故的性质、原因、伤害程度等有关的其他证明和资料。
        </div>
      </div>
      <div class="context">
        <div class="context-title">
          （二）特定药品医疗费用保险金理赔资料：
        </div>
        <div class="context-text">
          1、保险金给付申请书及投保凭证或投保人证明；
          <br />2、被保险人身份证明（身份证或户口本，若被保险人是未成年人，需同时提供监护人身份证件、关系证明）；
          <br />3、湖南医保结算单原件、购药发票原件及对应费用明细总清单；
          <br />4、疾病诊断证明/住院病历/病理报告/或相关检查报告原件/当地医保部门指定专科医生出具的特殊药品审批表；（含病案首页、入院记录、影像检查报告、首次确诊疾病诊断书等）
          <br />5、对于已经从当地基本医疗保险、公费医疗、城乡居民大病保险、慈善机构、其他费用补偿型医疗保险和其他途径获得补偿或给付的，需提供相应机构或单位出具的住院医疗费用结算证明或分报凭证；发票或收据上需盖报销机构或单位的公章；
          <br />6、受益人身份证明、银行卡复印件；
          <br />7、若由代理人代为申请保险金，则还应提供授权委托书、代理人法定身份证明等文件
          <br />8、所能提供的与确认保险事故的性质、原因、伤害程度等有关的其他证明和资料。
        </div>
      </div>
      <div class="context">
        <div class="context-title">
          （三）理赔申请公共材料重要提示
        </div>
        <div class="context-text">
          1、若被保险人是未成年人，需同时提供监护人身份证件、关系证明；
          <br />2、若被保险人身故，需同时提供医学死亡证明（医学死亡证明、火化证明或土葬证明、户口注销证明其中之一）、受益人关系证明；
          <br />3、若被保险人委托他人申请理赔，需签署授权委托书，授权委托书须理赔申请资格人亲笔签名，且需注明授权期限、授权范围或事项，并提供委托双方身份证件；
          <br />4、保险金作为被保险人遗产时，还需提供可证明合法继承权的相关权利文件及相应的放弃继承或授权其中一位受益人领取理赔的授权材料。
        </div>
      </div>
      <div class="img-context-title">
        <div class="img-text">
          三、理赔流程
        </div>
        <img src="../../assets/img/insu_detail/title-right.png" alt="" />
      </div>
      <div class="context">
        <div class="context-text">
          <br />1、关注“湖南爱民保”微信公众号，依次点击理赔服务＞理赔申请，根据提示上传理赔影像材料。
          <br />2、影像件材料提交后，进行线上审核。
          <br />3、线上审核后，根据需要提交理赔材料物理件。
          <br />4、支付赔款至指定账户。
        </div>
      </div>
      <div class="context-color">
        注：被保险人在每次特药申请前，均在湖南爱民保公众号平台提出理赔申请。
      </div>
      <div class="context">
        <div class="context-title">
          详细服务流程请见投保界面相关内容，上述展示系为方便了解理赔流程而作的假设，本产品展示药品清单涉及的海外特药，需在指定医疗机构由专家评定通过后使用，具体待报案后由服务专员进行指引。
        </div>
      </div>
      <div class="img-context-title">
        <div class="img-text">
          四、既往症人群
        </div>
        <img src="../../assets/img/insu_detail/title-right.png" alt="" />
      </div>
      <div class="context">
        <div class="context-text">
          <br />指参保人保险合同生效前已确诊罹患疾病属于既往症疾病范围的人群，既往症疾病范围
          <br />如下： <br />1、恶性肿瘤（含白血病、淋巴瘤）；
          <br />2、慢性肾功能不全（非透析治疗）；
          <br />3、慢性肾功能衰竭（尿毒症期）； <br />4、肝硬化；
          <br />5、肝功能不全； <br />6、缺血性心脏病（如冠心病、心肌梗死等）；
          <br />7、慢性心功能不全（心功能Ⅲ级及以上）； <br />8、脑梗死、脑出血；
          <br />9、罕见病。
        </div>
      </div>
      <div class="img-context-title">
        <div class="img-text">
          五、各项责任理赔申请材料重要提示
        </div>
        <img src="../../assets/img/insu_detail/title-right.png" alt="" />
      </div>
      <div class="context">
        <div class="context-text">
          <br />1、若被保险人是未成年人，需同时提供监护人身份证件、关系证明；
          <br />2、若被保险人身故，需同时提供医学死亡证明、受益人关系证明；
          <br />3、若被保险人委托他人申请理赔，需签署授权委托书，授权委托书须理赔申请资格人亲笔签名，且需注明授权期限、授权范围或事项，并提供委托双方身份证件。
        </div>
      </div>
      <div class="context-b">
        <br />
        注意事项
      </div>
      <div class="context">
        <div class="context-title">
          （一）理赔时效
        </div>
        <div class="context-text">
          1、客户将理赔材料提交齐全后，对性质明确、属于保险责任范围内的申请案件，将在7个工作日内进行核定。情形复杂的，将在30日内（需要投保人、被保险人或受益人补充提供有关证明和材料的时间不计算在内）做出核定。
          <br />2、请求给付保险金的诉讼时效期间为2
          年，自其知道或者应当知道保险事故发生之日起计算。
        </div>
      </div>
      <div class="context">
        <div class="context-title">
          （二）指定医疗机构
        </div>
        <div class="context-text">
          1、住院及特殊病种门诊医疗保险金：<span style="color:#EA332B;"
            >在中华人民共和国境内（不包括香港、澳门和台湾地区），且需符合参保地基本医疗保险规定的定点医疗机构（仅限普通住院部，不包括国际医疗、特需医疗、贵宾医疗、外宾医疗或者相类似的部门和科室）；如果异地就医时仅限中国大陆境内的二级及以上基本医疗保险定点医院</span
          >
          <br />2、特定药品医疗费用保险金（国内特药）：处方开具的指定医疗机构为符合参保当地基本医疗保险规定的定点医疗机构；药品购买的指定医疗机构为符合参保当地基本医疗保险规定的定点医疗机构及参保当地具备药品销售资质的药店。
          <br />3、特定药品医疗费用保险金（海外特药）：博鳌恒大国际医院、博鳌超级医院、博鳌国际医院、海南省人民医院乐城院区、海南省妇女儿童医学中心乐城分院。
        </div>
      </div>
      <div class="context">
        <div class="context-title">
          （三）指定专科医生
        </div>
        <div class="context-text">
          指定专科医生：指定专科医生应当同时满足以下四项资格条件：
          <br />1、具有有效的中华人民共和国《医师资格证书》；
          <br />2、具有有效的中华人民共和国《医师执业证书》，并按期到相关部门登记注册；
          <br />3、具有有效的中华人民共和国主治医师或主治医师以上职称的《医师职称证书》；
          <br />4、在二级或二级以上医院的相应科室从事临床工作三年以上。
        </div>
      </div>
      <div class="img-context-title">
        <div class="img-text">
          六、释义
        </div>
        <img src="../../assets/img/insu_detail/title-right.png" alt="" />
      </div>
      <div class="context">
        <div class="context-title">
          （一）恶性肿瘤（含白血病、淋巴瘤）
        </div>
        <div class="context-text">
          指恶性细胞不受控制的进行性增长和扩散，浸润和破坏周围正常组织,可以经血管、淋巴管和体腔扩散转移到身体其它部位,病灶经组织病理学检查(涵盖骨髓病理学检查）结果明确诊断,临床诊断属于世界卫生组织（WHO，World
          Health
          Organization）《疾病和有关健康问题的国际统计分类》（ICD）的恶性肿瘤类别及《国际疾病分类肿瘤学专辑》第三版（ICD-O-3）的肿瘤形态学编码属于（1）动态未定性肿瘤；（2）原位癌和非侵袭性癌；（3）恶性肿瘤（原发性）；（4）恶性肿瘤（转移性）；（5）恶性肿瘤（原发性或转移性未肯定）范畴的疾病。
        </div>
      </div>
      <div class="context">
        <div class="context-title">
          （二）慢性肾功能不全（非透析治疗）
        </div>
        <div class="context-text">
          指由多种原因导致的肾功能下降，使身体在排泄代谢废物和调节水电解质、酸碱平衡等方面出现紊乱的临床综合症后群。应同时满足以下条件：（1）血清肌酐（Scr）＞176μmol/L；（2）内生肌酐清除率（Ccr）＜80ml/min；③GFR＜90[ml/（min/1.73m2）]。
        </div>
      </div>
      <div class="context">
        <div class="context-title">
          （三）慢性肾功能衰竭（尿毒症期）
        </div>
        <div class="context-text">
          尿毒症期为慢性肾功能衰竭的晚期阶段，一般是指慢性肾脏病的4期和5期。此时患者的肾脏无法发挥正常的功能，导致患者出现水、电解质酸碱平衡紊乱和肾脏内分泌功能失调，还会出现代谢终末产物和毒性物质在体内大量潴留，从而引起一系列症状和体征。患者经诊断后已经进行规律性透析治疗或实施了肾脏移植手术。规律性透析是指每周进行血液透析或每天进行腹膜透析。
        </div>
      </div>
      <div class="context">
        <div class="context-title">
          （四）肝硬化
        </div>
        <div class="context-text">
          指由于一种或多种病因长期作用于肝脏而导致在肝细胞广泛坏死基础上产生肝脏纤维组织弥漫性增生，形成结节、假小叶，进而使肝脏正常结构和血供遭到破坏的一种慢性、进行性、弥漫性的肝病终末阶段。引起肝硬化的病因很多，例如：病毒性肝硬化、胆汁淤积性肝硬化、自身免疫性肝硬化、血吸虫性肝硬化、酒精性肝硬化、隐源性肝硬化等。超声影像学提示：肝实质回声增强、增粗，肝质地变硬，肝脏表面凹凸不平，不光滑(或)脾大，伴有门静脉高压征，而无其他原因解释。
        </div>
      </div>
      <div class="context">
        <div class="context-title">
          （五）肝功能不全
        </div>
        <div class="context-text">
          指因慢性肝脏疾病导致肝功能衰竭，有下列并发症之一者：严重感染、胸水或腹水、上消化道出血、肝性脑病、肝肾综合症；并符合以下标准之一：（1）B超或CT影像学证实，脾增大，食道或胃底静脉曲张或腹水征（+），少数可出现肝性胸水；（2）肝活检组织检查见假小叶形成；（3）检查指标持续异常：凝血功能异常，氨基转移酶水平升高、胆红素水平升高。
        </div>
      </div>
      <div class="context">
        <div class="context-title">
          （六）缺血性心脏病（含冠心病、心肌梗死）
        </div>
        <div class="context-text">
          冠状动脉粥样硬化性心脏病（简称冠状动脉心脏病或冠心病,有时被称为缺血性心脏病或冠状动脉病)，是指由于冠状动脉发生粥样硬化引起管腔狭窄或闭塞，导致心肌缺血、缺氧或坏死而出现胸痛、胸闷等不适的一种缺血性心脏病。本产品定义的冠心病指以下三类：（1）心肌梗死型；（2）缺血性心肌病型；（3）猝死型。
          <br />心肌梗死指由于冠状动脉闭塞或梗阻引起部分心肌严重的持久性缺血造成急性心肌坏死。
          <br />需满足下列标准至少三项：（1）缺血性胸痛＞15分钟，含服硝酸甘油缓解不明显；（2）心电图提示新发或一过性ST压低≥0.1mV，或T波倒置≥0.2mV；（3）超声心动图有典形性节段性改变；（4）以往冠状动脉造影阳性，狭窄≥50％；（5）有明确急性心肌梗塞病史。
        </div>
      </div>
      <div class="context">
        <div class="context-title">
          （七）慢性心功能不全（心功能III级及以上）
        </div>
        <div class="context-text">
          指各种原因导致心脏泵血功能受损，心排血量不能满足全身组织基础代谢需要的综合征，当心功能不全出现呼吸困难、活动受限、体液潴留等临床症状时即称为心力衰竭。
          <br />应符合以下标准至少三项：（1）基础心脏病变；（2）NYHA心功能III级心脏病患者体力活动明显受限，休息时无症状，但小于一般体力活动即可引起过度疲劳、心悸、气喘或心绞痛。或NYHA心功能IV级心脏病患者不能从事任何体力活动，休息状态下也出现心衰症状，体力活动后加重；（3）心电图、负荷试验、X
          线、超声心动图等客观检查评估心脏病变C
          级及以上；（4）心脏射血分数（EF）＜50%；（5）B型钠尿肽（BNP）＞100pg/ml。
        </div>
      </div>
      <div class="context">
        <div class="context-title">
          （八）脑梗死、脑出血
        </div>
        <div class="context-text">
          指因脑血管的突发病变引起脑血管出血、栓塞或梗塞，须由头颅断层扫描（CT）、核磁共振检查（MRI）等影像学检查证实,并导致神经系统永久性的功能障碍，同时符合以下三项标准：（1）急性起病（少数可亚急性起病），临床表现为局灶性神经功能缺失（如肢体瘫痪、感觉障碍、颅神经障碍、失语等），甚至伴有意识障碍；（2）经CT、MRI或CSF检查确诊的脑梗死、脑出血及蛛网膜下腔出血；（3）一肢（含）以上肢体肌力3级（含）以下；语言能力完全丧失，或严重咀嚼吞咽功能障碍；自主生活能力完全丧失，无法独立完成六项基本日常生活活动中的两项。
        </div>
      </div>
      <div class="context">
        <div class="context-title">
          （九）罕见病
        </div>
        <div class="context-text">
          参见《关于公布第一批罕见病目录的通知》[国卫医发〔2018〕10号]
        </div>
      </div>
      <div class="img-context-title">
        <div class="img-text">
          七、责任免除
        </div>
        <img src="../../assets/img/insu_detail/title-right.png" alt="" />
      </div>
      <div class="context">
        <div class="context-title">
          1、因下列情形之一，导致被保险人支出医疗费用的，保险人不承担给付保险金的责任：
        </div>
        <div class="context-text">
          （1）应当由第三者负担的；
          <br />（2）应当从工伤保险、生育保险中支付的；
          <br />（3）应当由公共卫生负担的；
          <br />（4）在境外（含香港特别行政区、澳门特别行政区、台湾地区及境外国家）就医发生的医疗费用；
          <br />（5）被保险人在保险期间停止参加湖南省各市州（含省本级）社会基本医疗保险的，在其停止享受基本医疗保障待遇期间发生的医疗费用；
          <br />（6）基本医疗保险完全不予报销的医疗费用，如各种美容、整形、非功能性矫形、减肥、非医学必需的激素治疗，治疗雀斑、脱痣、护肤、镶牙、洁牙，配镜、装配假眼、假肢、助听器等发生的费用；
          <br />（7）非疾病治疗项目类，如各种健康体检、婚前检查、旅游体检、职业体检、出境体检等费用；
          <br />（8）各种不育（孕）症、性功能障碍的诊疗项目（如：男性不育、女性不孕检查、治疗费，鉴定性病检查、治疗费，违反计划生育的一切医疗费用），各类医疗鉴定、各种教学性、科研性和临床验证性的诊疗项目费用；
          <br />（9）膏方费用以及以下主要起滋补保健用途以及含国家珍贵、濒危野生动植物药材的药品和中药饮片费用，上述药品和中药饮片具体包括：阿胶、白糖参、朝鲜红参、穿山甲（醋山甲、炮山甲）、玳瑁、冬虫夏草、蜂蜜、狗宝、龟鹿二仙胶、哈蟆油、海龙、海马、猴枣、酒制蜂胶、羚羊角尖粉（羚羊角镑片、羚羊角粉）、鹿茸（鹿茸粉、鹿茸片）、马宝、玛瑙、牛黄、珊瑚、麝香、天山雪莲、鲜石斛（铁皮石斛）、西红花（番红花）、西洋参、血竭、燕窝、野山参、移山参、珍珠、紫河车、各种动物脏器（鸡内金除外）和胎、鞭、尾、筋、骨；
          <br />注：以上所列药品和中药饮片均包括生药及炮制后的药材及饮片。
          <br />（10）预防性疫苗和避孕药品费用，主要用于治疗脱发、减肥、美容、戒烟、戒酒等药品费用；
          <br />（11）除当地基本医疗保险相关制度以外，其他当地法律、法规、政策、文件及本产品适用条款规定不予支付的医疗费用，保险人不承担给付保险金责任。
        </div>
      </div>
      <div class="context">
        <div class="context-title">
          2、针对“特定药品费用医疗保险金”
        </div>
        <div class="context-text">
          对于使用本产品约定的特定药品的被保险人，如存在下列情形的，保险人不承担给付保险金的责任：
          （1）药品处方的开具与本产品《“湖南爱民保”特定药品目录》（详见附表一）的支付范围不符；
          <br />（2）未由本产品基本医保定点医院或其他指定医院的专科医生开具处方，或未在指定医院或指定药店购买的药品；
          <br />（3）每次药品处方开具时间超过一个月的，对超出一个月部分金额的药品费用；
          <br />（4）药品处方的开具与国家食品药品监督管理总局批准的该药品说明书中所列明的适应症用法用量不符或相关医学材料不能证明被保险人所患疾病符合使用特定药物的指征；
          <br />（5）被保险人符合慈善援助用药申请，但因被保险人未提交相关申请或者提交的申请材料不全，导致援助项目申请未通过而发生的药品费用；被保险人通过援助审核，但因被保险人原因未领取援助药品，视为被保险人自愿放弃本产品相关保险权益；
          <br />（6）进行未经科学或者医学认可的试验性或者研究性治疗。
        </div>
      </div>
      <div class="fujian">
        <span class="line"></span><span>附表一：特定药品清单目录</span>
      </div>
      <img
        class="tyqd"
        :src="cdnresources + '/prod/images/hunan2021/LPXZ_2021_05.png'"
        alt=""
      />
      <img
        class="tyqd"
        :src="cdnresources + '/prod/images/hunan2021/LPXZ_2021_06.png'"
        alt=""
      />
      <img
        class="tyqd"
        :src="cdnresources + '/prod/images/hunan2021/LPXZ_2021_07.png'"
        alt=""
      />
      <img
        class="tyqd"
        :src="cdnresources + '/prod/images/hunan2021/LPXZ_2021_08.png'"
        alt=""
      />
      <img
        style="margin-top:20px"
        class="tyqd"
        :src="cdnresources + '/prod/images/xiangaibao/lpxz-zdyd01.png'"
        alt=""
      />
      <img
        class="tyqd"
        :src="cdnresources + '/prod/images/xiangaibao/lpxz-zdyd02.png'"
        alt=""
      />
      <img
        class="tyqd"
        :src="cdnresources + '/prod/images/xiangaibao/lpxz-zdyd03.png'"
        alt=""
      />
      <img
        class="tyqd"
        :src="cdnresources + '/prod/images/xiangaibao/lpxz-zdyd04.png'"
        alt=""
      />
      <img
        class="tyqd"
        :src="cdnresources + '/prod/images/xiangaibao/lpxz-zdyd005.png'"
        alt=""
      />
      <img
        class="tyqd"
        :src="cdnresources + '/prod/images/xiangaibao/lpxz-zdyd06.png'"
        alt=""
      />
    </div>
  </div>
</template>

<script>
  import { cdnresources } from '@/util/config'
  export default {
    data() {
      return {
        cdnresources
      }
    },
    components: {}
  }
</script>

<style scoped lang="scss">
  .company-appointment-box {
    min-height: 100vh;
    background: #fff;
    padding-bottom: xvw(40);
    .banner {
      width: 100%;
    }
  }
  .table {
    width: 100%;
    padding: xvw(24);
    .lpxz-title1 {
      display: block;
      width: xvw(334);
      padding: xvw(20) 0;
    }
    .lpxz-title2 {
      display: block;
      width: xvw(264);
      padding: xvw(20) 0;
    }
    .lpxz-title3 {
      display: block;
      width: xvw(262);
      padding: xvw(20) 0;
    }
    .lpxz-title4 {
      display: block;
      width: xvw(295);
      padding: xvw(20) 0;
    }
    .lpxz-title5 {
      display: block;
      width: xvw(590);
      padding: xvw(20) 0;
    }
    .lpxz-title6 {
      display: block;
      width: xvw(221);
      padding: xvw(20) 0;
    }
    .img-context-title {
      display: flex;
      align-items: center;
      margin-top: xvw(30);
      .img-text {
        font-size: xvw(32);
        background-image: linear-gradient(#ffffff, #fff1f1);
      }
      img {
        width: xvw(100);
        height: xvw(32);
        margin-left: xvw(20);
      }
    }
    .context {
      font-size: xvw(24);
      color: #333333;
      line-height: xvw(40);
      .context-title {
        font-weight: 600;
        margin: xvw(30) 0 xvw(20);
      }
    }
    .fujian {
      display: flex;
      color: #696969;
      font-size: xvw(28);
      font-weight: 700;
      margin: xvw(40) 0 xvw(30);
      .line {
        width: xvw(4);
        height: xvw(28);
        background: #e73030;
        margin-right: xvw(10);
      }
    }
    .tyqd {
      display: block;
      margin: 0;
      padding: 0;
      width: 100%;
    }
    .context-b {
      font-size: xvw(32);
      font-weight: 700;
      color: #333333;
    }
    .context-color {
      background: #fff1f1;
      font-size: xvw(24);
      font-weight: 700;
      color: #333333;
      line-height: xvw(40);
      padding: xvw(15);
      border-radius: xvw(12);
      margin-top: xvw(10);
    }
  }
</style>
